import { useAdminApiRequestStatus } from "../../../hooks/useAdminApiRequestStatus";
import Loading from "./Loading";
import { useEffect, useState } from "react";

export const ApiShade = () => {
  const [show, setShow] = useState(false);

  const isQueryPending = useAdminApiRequestStatus();

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setShow(isQueryPending);
      },
      isQueryPending ? 250 : 0
    );
    return () => clearTimeout(timer);
  }, [isQueryPending]);

  if (!show) {
    return null;
  }

  return <Loading />;
};
